import React, { useState } from 'react';
import { AddButton, EmptyState } from '../../../components/admin/Shared';
import CreatePartnerModal, {
  AdminPartner,
} from '../../../components/admin/CreatePartnerModal';

interface Partner {
  id: number;
  name: string;
}

interface Props {
  partners: Partner[];
  onSelect: (partnerId: number) => void;
  onPartnerCreated?: (partner: AdminPartner) => void;
}

export default function PartnersListTab({ partners, onSelect, onPartnerCreated }: Props) {
  const [showCreate, setShowCreate] = useState(false);
  const showCount = partners.length > 1;
  const hasPartners = partners.length > 0;

  return (
    <section className="admin-partners-list">
      {hasPartners && (
        <header className="admin-partners-list__head">
          {showCount && (
            <p
              className="admin-partners-list__count"
              aria-live="polite"
              aria-label={`${partners.length} partners`}
            >
              <span className="admin-partners-list__count-num" aria-hidden="true">
                {partners.length}
              </span>
              <span className="admin-partners-list__count-label" aria-hidden="true">
                Partners
              </span>
            </p>
          )}
          <AddButton onClick={() => setShowCreate(true)}>Add partner</AddButton>
        </header>
      )}

      {!hasPartners ? (
        <EmptyState
          title="No partners yet"
          body="Create your first partner to assign couriers, warehouses, or master accounts."
          cta={<AddButton onClick={() => setShowCreate(true)}>Add partner</AddButton>}
        />
      ) : (
        <ul className="partner-card-grid">
          {partners.map((p) => (
            <li
              key={p.id}
              className="partner-card"
              onClick={() => onSelect(p.id)}
              role="button"
              tabIndex={0}
              aria-label={`Open ${p.name}`}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  onSelect(p.id);
                }
              }}
            >
              <div className="partner-card__body">
                <h3 className="partner-card__name">{p.name}</h3>
                <p className="partner-card__links">
                  <span>Pricing</span>
                  <span aria-hidden="true">·</span>
                  <span>Vehicles</span>
                  <span aria-hidden="true">·</span>
                  <span>Service Areas</span>
                </p>
              </div>
              <span className="partner-card__chevron" aria-hidden="true" />
            </li>
          ))}
        </ul>
      )}

      <CreatePartnerModal
        show={showCreate}
        close={() => setShowCreate(false)}
        onSuccess={(partner) => {
          if (onPartnerCreated) onPartnerCreated(partner);
        }}
      />
    </section>
  );
}
